import React from 'react';
import ScalarSpreadsheet from 'components/ScalarSpreadsheet';
import { BacksolveSummaryTableProps } from './types';

const BacksolveSummaryTable = ({ spreadsheets, onChange, format, formatDispatch }: BacksolveSummaryTableProps) => {
  const { backsolveSummarySheet } = spreadsheets;
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: ScalarSpreadsheet is not typed
    <ScalarSpreadsheet
      {...backsolveSummarySheet}
      id="backsolve-summary-table"
      tableTerms={{ tableSlug: 'backsolve-summary-table' }}
      onChange={onChange}
      sheet={backsolveSummarySheet}
      displayLegend={false}
      format={format}
      formatDispatch={formatDispatch}
      alwaysDisplayLegend={false}
    />
  );
};

export default BacksolveSummaryTable;
